import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { formatDate } from "@/lib/format";
import { Loader } from "@/components/common";
import { PageTitle, Panel } from "./AdminShell";
import { TICKET_STATUS, TicketThread } from "@/pages/client/ClientSupport";

export default function AdminSupport() {
  const [tickets, setTickets] = useState(null);
  const [filter, setFilter] = useState("all");
  const [active, setActive] = useState(null);
  const load = useCallback(() => api.get("/support/tickets").then((r) => setTickets(r.data)), []);
  useEffect(() => { load(); }, [load]);
  if (!tickets) return <Loader />;

  const list = filter === "all" ? tickets : tickets.filter((t) => t.status === filter);
  const counts = { open: tickets.filter((t) => ["ouvert", "en_cours"].includes(t.status)).length };

  return (
    <div>
      <PageTitle>Support {counts.open > 0 && <span className="text-sm font-bold text-[#C85A32]">({counts.open} en attente)</span>}</PageTitle>
      <div className="flex gap-2 mb-4 flex-wrap">
        {[["all", "Tous"], ["ouvert", "Ouverts"], ["en_cours", "En cours"], ["resolu", "Résolus"], ["ferme", "Fermés"]].map(([v, l]) => (
          <button key={v} onClick={() => setFilter(v)} data-testid={`support-filter-${v}`} className={`px-4 py-2 rounded-lg text-sm font-semibold ${filter === v ? "bg-[#C85A32] text-white" : "bg-white border border-slate-200 text-slate-600"}`}>{l}</button>
        ))}
      </div>
      <div className="space-y-2">
        {list.length === 0 && <p className="text-sm text-slate-400">Aucun ticket.</p>}
        {list.map((t) => (
          <Panel key={t.id} className="p-4 cursor-pointer hover:border-[#C85A32]" data-testid={`admin-ticket-${t.id}`}>
            <button onClick={() => setActive(t.id)} className="w-full text-left">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-num text-xs text-slate-400">{t.ticket_number}</span>
                <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${TICKET_STATUS[t.status]?.color}`}>{TICKET_STATUS[t.status]?.label}</span>
                <span className="text-xs text-slate-400">{t.category}</span>
                <span className="ml-auto text-xs text-slate-400">{formatDate(t.updated_at)}</span>
              </div>
              <p className="font-semibold mt-1">{t.subject}</p>
              <p className="text-sm text-slate-500">{t.user_name} · {t.user_email}</p>
            </button>
          </Panel>
        ))}
      </div>
      {active && <TicketThread id={active} staff onClose={() => setActive(null)} onChanged={load} />}
    </div>
  );
}
